import { getGenericChannelId } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import DisabledAlertBase from './DisabledAlertBase';
import UILink from 'UIComponents/link/UILink';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { useGetChannelName } from '../../hooks/useGetChannelName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BoldedDiv = styled.div.withConfig({
  displayName: "DisabledAlertOptedOut__BoldedDiv",
  componentId: "sc-1edaut-0"
})(["font-weight:600;"]);
const AlertMessage = genericChannelId => {
  const channelName = useGetChannelName(genericChannelId);
  const url = genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID ? 'https://knowledge.hubspot.com/inbox/collect-consent-for-whatsapp-conversations' : 'https://knowledge.hubspot.com/sms/collect-and-manage-consent-to-send-sms-messages';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(BoldedDiv, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.capability-editor.disabled-editor.optedOut.emphasizedText",
        options: {
          channelName
        }
      })
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "composer-ui.capability-editor.disabled-editor.optedOut.description_jsx",
      elements: {
        UILink
      },
      options: {
        href: url,
        target: '_blank'
      }
    })]
  });
};
AlertMessage.displayName = 'AlertMessage';
const DisabledAlertOptedOut = ({
  message
}) => {
  const genericChannelId = getGenericChannelId(message);
  return /*#__PURE__*/_jsx(DisabledAlertBase, {
    message: AlertMessage(genericChannelId),
    type: 'danger'
  });
};
DisabledAlertOptedOut.displayName = 'DisabledAlertOptedOut';
export default DisabledAlertOptedOut;